import TopHeadScreen from "../../component/layout/tophead";
import SidebarScreen from "../../component/layout/sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { HiOutlineLightBulb } from "react-icons/hi";
import { FaCheck } from "react-icons/fa6";
import { BsBriefcase } from "react-icons/bs";
import { SlGraduation } from "react-icons/sl";
import { LiaAwardSolid } from "react-icons/lia";
import { useState } from "react";

import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import { useSelector } from "react-redux";
import AddExpericeModal from "./common/add-experice-modal";
import { RootState } from "../../store/store";
import { AppRoute } from "../../router/routerConstants";
import AgentSidebarScreen from "../../component/layout/agent-sidebar";
import AgentTopHeadScreen from "../../component/layout/agent-header";

const ProfileExperienceScreen = () => {
  const [showEXP, setShowEXP] = useState(false);
  const handleCloseEXP = () => setShowEXP(false);
  const handleShowEXP = () => setShowEXP(true);
  const [NavigateTo] = useCustomNavigate();
  const { user } = useSelector((state: RootState) => state.authSlice);
  // const dispatch = useDispatch();
  // const { resumeDetails } = useSelector(
  //   (state: RootState) => state.resumeSlice
  // );

  const prevHandler = () => {
    if (user && user?.role === "jobseeker") {
      NavigateTo(AppRoute.JOBSEEKER_MY_RESUME);
    } else if (user && user?.role === "localagents") {
      NavigateTo(AppRoute.AGENT_MY_RESUME);
    }
  };

  return (
    <>
      <div className="main">
        <section className="profileJobDetails-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar position-relative p-0">
                {user && user?.role === "jobseeker" && <SidebarScreen />}
                {user && user?.role === "localagents" && <AgentSidebarScreen />}
              </div>
              <div className="col-lg-10 rightcontent p-0">
                {user && user?.role === "jobseeker" && <TopHeadScreen />}
                {user && user?.role === "localagents" && <AgentTopHeadScreen />}
                <div className="profile-account-details-holder pt-3 common-padd-lt-rt">
                  <div className="row">
                    <div className="col-lg-12 mb-4">
                      <div className="profile-account-details">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="title">
                              <h2>My Resume</h2>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="myResume-holder">
                              <div className="login-form-area add-password-form mt-5">
                                <Form>
                                  <div className="stepbar">
                                    <ul>
                                      <li className="checked">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                        <a href="#">
                                          <div className="icon-progress">
                                            <span>
                                              <FaCheck />
                                            </span>
                                          </div>
                                          <p>Step 1</p>
                                          <h4>About You</h4>
                                        </a>
                                      </li>
                                      <li className="inprogress">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                        <a href="#">
                                          <div className="icon-progress">
                                            <span>
                                              <BsBriefcase />
                                            </span>
                                          </div>
                                          <p>Step 2</p>
                                          <h4>Experience</h4>
                                        </a>
                                      </li>
                                      <li>
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                        <a href="#">
                                          <div className="icon-progress">
                                            <span>
                                              <SlGraduation />
                                            </span>
                                          </div>
                                          <p>Step 3</p>
                                          <h4>Education</h4>
                                        </a>
                                      </li>
                                      <li>
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                        <a href="#">
                                          <div className="icon-progress">
                                            <span>
                                              <LiaAwardSolid />
                                            </span>
                                          </div>
                                          <p>Step 4</p>
                                          <h4>Achievements</h4>
                                        </a>
                                      </li>
                                      <li>
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                        <a href="#">
                                          <div className="icon-progress">
                                            <span>
                                              <HiOutlineLightBulb />
                                            </span>
                                          </div>
                                          <p>Step 5</p>
                                          <h4>Skills</h4>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                  <h3>Ready to build an impressive resume?</h3>
                                  <h4>
                                    Start by including your work experiences.
                                  </h4>
                                  <div className="row">
                                    <div className="col-lg-12">
                                      <div className="btn-holder">
                                        <Button
                                          className="btn btn-primary"
                                          onClick={prevHandler}
                                        >
                                          Prev
                                        </Button>
                                        <Button
                                          className="btn btn-primary"
                                          onClick={handleShowEXP}
                                        >
                                          Add Work Experience
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                </Form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />

      {/* Add Work Experience Modal */}

      <AddExpericeModal show={showEXP} onClose={handleCloseEXP} />

      {/* Add Work Experience Modal */}
    </>
  );
};

export default ProfileExperienceScreen;
